var mp = mp || {};

// Form validation
//----------------------------------------------------------
mp.formContact = function() {
    var $form = $('#form-contact');
        $submitBtn = $form.find('button.btn');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            "full_name": {
                required: true,
                minlength: 2
            },
            "email": {
                required: true,
                email: true
            },
            "message": {
                required: true,
                minlength: 10
            },
            "terms": {
                required: true
            },
        },
        errorPlacement: function(error, element) {
            //element.addClass("test");
        },

        invalidHandler: function(event, validator) {
            // $submitBtn.toggleClass('disabled');
        },

        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass);
            $(element).parents('.form__group').addClass(errorClass);
        },

        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass);
            $(element).parents('.form__group').removeClass(errorClass);
        },

        submitHandler: function(form) {
            $submitBtn.attr('disabled','disabled');
            var $formData = new FormData(form);

            $.ajax({
                url: form.action,
                type: form.method,
                data: $formData,
                cache: false,
                contentType: false,
                processData: false,
                success: function(response) {
                    $form.html("<div class='form__group form__group--full'><h5>"+response.message+"</h5></div>");
                    
                    $('html, body').animate({
                        scrollTop: $form.offset().top - 150
                    }, 800);
                }            
            });

            // var $formData = new FormData(form);
            // var $sitekey = $form.find('input[name=recaptcha_site_key]').val();

            // grecaptcha.ready(function() {
            //     grecaptcha.execute($sitekey).then(function(token) {
            //         $formData.append('token', token);

            //         $.ajax({
            //             url: form.action,
            //             type: form.method,
            //             data: $formData,
            //             cache: false,
            //             contentType: false,
            //             processData: false,
            //             success: function(response) {
            //                 $form.html("<div class='form__group form__group--full'><h5>"+response.message+"</h5></div>");
                            
            //                 $('html, body').animate({
            //                     scrollTop: $form.offset().top - 100
            //                 }, 800);
            //             }            
            //         });
            //     });
            // });
        }
    });
};


$(document).ready(function (){
    mp.formContact();
});